import React from "react";

import Layout from "../containers/layout";
import GraphQLErrorList from "../components/graphql-error-list";
import SEO from "../components/seo";
import PageContainer from "../components/pageContainer";
import FromMain from "../components/formMain";

const Form = (props) => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const magazinPreview = data && data?.magazinPreview?.nodes;
  const tags = data && data?.tags?.nodes;
  const allServices = data && data?.allServices?.nodes;
  const actionsData = data && data?.actions?.actions;
  return (
    <Layout services={allServices} tags={tags} magazin={magazinPreview}>
      <SEO
        title={"Konzultace"}
        description={"Napište nám"}
        keywords={["Konzultace", "Napište nám"]}
      />
      <PageContainer>
        <FromMain actionsData={actionsData} />
      </PageContainer>
    </Layout>
  );
};

export default Form;
